module.exports = __webpack_public_path__ + "static/media/design-service.df8ff693.svg";